import { type FunctionComponent, useState } from 'react';
import style from './Avatar.module.scss';

interface Props {
  name: string;
  picture?: string;
}

const sourceOf = (picture: string) => {
  try {
    const url = new URL(picture);
    if (url.hostname.endsWith('gravatar.com')) {
      url.searchParams.set('d', '404');
    }
    return url.toString();
  } catch {
    return null;
  }
};

const initialOf = (name: string) => [...name.trim()][0]?.toLocaleUpperCase() ?? '?';

export const Avatar: FunctionComponent<Props> = ({ name, picture }) => {
  const source = picture ? sourceOf(picture) : null;
  const [failed, setFailed] = useState<string | null>(null);

  if (source && failed !== source) {
    return (
      <img
        src={source}
        alt={name}
        referrerPolicy="no-referrer"
        className={style.avatar}
        onError={() => setFailed(source)}
      />
    );
  }

  return (
    <span role="img" aria-label={name} className={`${style.avatar} ${style.initial}`}>
      {initialOf(name)}
    </span>
  );
};
